import { Component, computed, inject } from '@angular/core';
import { currentUser } from '@/utils/admin-utils';
import { CurrentUserService } from '@services/current-user.service';
import { landingTilesFor } from '@pages/landing-page/landing-tiles';

@Component({
  standalone: false,
  selector: 'wr-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
  private readonly currentUserService = inject(CurrentUserService);

  readonly user = currentUser();

  readonly firstName = computed(() => this.user()?.firstName ?? '');

  readonly tiles = computed(() =>
    landingTilesFor(this.user()?.tenantType)
      .filter(tile => !tile.permission || this.currentUserService.hasPrivilege(tile.permission)),
  );

  readonly greeting = computed(() => {
    const h = new Date().getHours();
    if (h < 12) return 'Guten Morgen';
    if (h < 18) return 'Guten Nachmittag';
    return 'Guten Abend';
  });

  readonly currentDate = new Date().toLocaleDateString('de-AT', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
